import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'components/v2/button/Button';
import { cn } from 'utils/helpers';
import UpdatesCard from '../UpdatesCard';

type Props = {
  className?: string;
  handleDismiss: (eventId: string, expiresAt?: Date) => void;
  isShadows?: boolean;
};

const CalendarCard = ({
  handleDismiss,
  isShadows = true,
  className,
}: Props) => {
  const navigate = useNavigate();
  const cardRef = useRef<HTMLDivElement>(null);
  const [cardHeight, setCardHeight] = useState(0);

  useEffect(() => {
    if (cardRef.current) {
      setCardHeight(cardRef.current.clientHeight);
    }
  }, [cardRef.current]);

  return (
    <>
      {isShadows && (
        <div
          className="absolute bg-transparent w-full shadow-[0px_50px_110px_-61px_#AAA8FF] rounded-[6rem] z-[-1]"
          style={{ height: cardHeight }}
        ></div>
      )}

      <UpdatesCard
        isShadows={isShadows}
        cardRef={cardRef}
        title="Sync your calendar"
        description="Allows you to import your Google Calendar time blocks and push Calido invites!"
        emoji="🗓️"
        className={cn('shadow-none', className)}
        actionsChildren={
          <>
            <Button
              className="min-w-[65%] py-3 text-[0.875rem] font-semibold"
              variant="primary"
              onClick={() => {
                navigate('/settings/edit/availability');
              }}
            >
              Sync Google Calendar
            </Button>
            <Button
              variant="secondary"
              className="py-3 text-[0.875rem]"
              onClick={() => {
                handleDismiss('calendar');
              }}
            >
              Dismiss
            </Button>
          </>
        }
      />
    </>
  );
};

export default CalendarCard;
